export default {"mobileHeader":"_9wf6e","navBar":"mIEPM","burgerLogo":"lVA8t","burgerIcon":"GM7md","iconWrapper":"OvYeF","ocIcon":"mrfZI","subMenu":"yHWnA"};